<template>
    <div class="md search">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .md.search::v-deep {

        /*ul*/.list {
            @extend %reset;

            > li {
                display: inline-block;

                @include media('phone') {
                    display: block;
                }

                + li {

                    @include media('phone') {
                        margin-top: $interval-xs;
                    }
                }
            }
        }
        
        .input, & > a, & > button {
            margin: 1px;
        }

        .lo.footer & {
            padding: $interval-s;

            .cp.input.text {

                input {
                    width: 184px;
                }
            }
        }
    }
</style>
